import apiService from 'library/api-service';
import { createAsyncThunk } from '@reduxjs/toolkit';

const getEnvironmentTypes = createAsyncThunk('getEnvironmentTypes', async () => {
  const response = await apiService.getEnvironmentTypes();

  return { environmentTypes: response.data };
});

const environmentTypesActions = { getEnvironmentTypes };

export default environmentTypesActions;
